(function ($, Global) {
    try {
    Global.cookieManager = new CookieManager();
        $(document).ready(function () {

            /**
             * Initialisation du SSO 
             */
            var ssoModel = new SsoModel();
            ssoModel.initEvents();

            /**
             * Initialisation des services avec le consentement
             */
            setTimeout(function () {
                var services = Global.cookieManager.servicesActivate();
                Global.cookieManager.activate(services);
            }, 1000)

            /**
             * Initialisation de Matomo via un push event vers GTM
             */
            Global.dataLayer.push({ event: 'initMatomo' });

            /** 
             *  Initialisation critique
             */
            initPageDevis();
            
            var signinModalComponent = new SigninModalComponent();
            signinModalComponent.initEvents();

            var signupModalComponent = new SignupModalComponent();
            signupModalComponent.initEvents();

            var signupNewsletterModalComponent = new SignupNewsletterModalComponent();
            signupNewsletterModalComponent.initEvents();

            var contactModalComponent = new ContactModalComponent();
            contactModalComponent.initEvents();

            var authModel = new AuthModel();
            var formLoginComponent = new FormLoginComponent(authModel);
            var formRegisterComponent = new FormRegisterComponent(authModel);

            formLoginComponent.initEvents();
            formRegisterComponent.initEvents();

            initComponentFormMdpReset(authModel);
            initComponentFormMdpForget(authModel);  

            initComponentTransactionCommand();
            initComponentFormContact();
            initComponentFormContactModal();
            initComponentFormLicenceGlobale();


            /**
		     * Initialisation des composants
		     */
            var loadingComponent = new LoadingComponent();
            loadingComponent.initEvents();


		    /**
		     * Initialisation des pages
		     */

            var veilleModel = new VeilleModel();
            veilleModel.subscribe();


            initPageArchives();
            initPageArticleOrInsiders();
            initPageFeuilleton();
            initPageLanding();
            initPageDossier();
            initPageGratuit();
            initPageListeOrRechercheOrFeuilleton(veilleModel);
            initPageTag();
            initPageStatic();
            initPageQSNStatic();
            initPageInsiders();
            initPageOffres();
            initPageSimulateur();
            initPageRecap();
            initPageOffre();

		    

            initComponentFormNewsletter();
            initComponentButtonLogout(authModel);
            initComponentFormOffrirArticleEnvoi();
            initComponentHeader();
            initComponentAccordionLanding();
            initComponentArticle();
            initComponentAlerteCarousel();
            initComponentListKeywords(veilleModel);
            initComponentTools();
            initComponentListArticles();
            initComponentFormUnsub();
            initComponentFilters();
            initComponentFiltersV2();
            initComponentBlocAccount();
            initComponentBlocAbo();
            initComponentMenutop();
            initComponentMenuInsiders();
            initComponentMenuFeuilleton();
            initComponentNavFixed();
            initComponentModalCookieConsent();
            initComponentModalCookieConsentSettings();
            initComponentModalSearch();
            initComponentBtnMoreArticle();
            initComponentButtonScrollUp();
            initComponentBannerNewsletter();
            initComponentBannerOfferPme();
            initComponentMessages();
            initComponentBannerLancementLaLettre();
            //Désactivation bandeau notif
            //initComponentMessagePush();
            initComponentMessageCookie();
            initComponentMenuleft();
            initComponentMenuright();
            initComponentCarte();
            initComponentModalDevis();
            initComponentCarouselUne();
            initComponentModalImgFullscreen();
            initComponentProgressReading();
            initComponentProgressBar();
            initComponentVeilleFeuilleton(veilleModel);


            initialisationPaywallPoool();
            initialisationEngagePoool();
            initialisationCountdown();
        });
    } catch (err) {
        Global.Sentry.captureException(err);
    }
}(jQuery, window));

function isBrave() {
    if (window.navigator.brave != undefined) {
        if (window.navigator.brave.isBrave.name == "isBrave") {
            window.cookieManager.continueWithout();
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
function initPageArchives() {
    if ($('.page-archives').exists()) {
        var archiveModel = new ArchiveModel()
        var archivesPage = new ArchivesPage(archiveModel);
        var filtersMobileComponent = new FiltersMobileComponent();

        archivesPage.initEvents();
        filtersMobileComponent.initEvents();
    }
}
function initPageArticleOrInsiders() {
    if ($('.page-article').exists() || $('.page-insiders').exists()) {
        var articlePage = new ArticlePage();

        articlePage.initEvents();
    }
}
function initPageFeuilleton() {
    if ($('.page-feuilleton').exists()) {
        var feuilletonPage = new FeuilletonPage();

        feuilletonPage.initEvents();
    }
}
function initPageLanding() {
    if ($('.landing').exists()) {
        var landingModel = new LandingModel();
        var landingPage = new LandingPage(landingModel);

        landingPage.initEvents();
    }
}
function initPageDossier() {
    if ($('.page-dossier').exists()) {
        var dossierPage = new DossierPage();

        dossierPage.initEvents();
    }
}
function initPageGratuit() {
    if ($('.page-gratuit').exists()) {
        var gratuitPage = new GratuitPage();

        gratuitPage.initEvents();
    }
}

function initPageListeOrRechercheOrFeuilleton(veilleModel) {
    if ($('.page-recherche, .page-liste, .page-feuilleton').exists()) {
        var searchModel = new SearchModel();

        var searchPage = new SearchPage(searchModel, veilleModel);
        searchPage.initEvents();
    }
}

function initPageTag() {
    if ($(".page-tag").exists()) {
        var tagPage = new TagPage();

        tagPage.initEvents();
    }
}

function initPageStatic() {
    if ($('.page-static').exists()) {
        var staticPage = new StaticPage();

        staticPage.initEvents();
    }
}

function initPageQSNStatic() {
    if ($('.page-qsn').exists()) {
        var staticQSNPage = new StaticQSNPage();

        staticQSNPage.initEvents();
    }
}
function initPageInsiders() {
    if ($('.page-insiders').exists()) {
        var insidersPage = new InsidersPage();

        insidersPage.initEvents();
    }
}
function initPageOffres() {
    if ($('.page-abonnements.offers').exists()) {
        var abonnementsPage = new AbonnementsPage();

        abonnementsPage.initEvents();
    }
    if ($('#modalSimuIndependant').exists()) {
        SimulatorPage('simulatorModalWrapper');
        var modalDevisComponent = new ModalDevisComponent();

        modalDevisComponent.initEvents();
    }
}
function initPageSimulateur() {
    if ($('.page-simulator').exists()) {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
        SimulatorPage('simulatorWrapper');
    }
}
function initPageRecap() {
    if ($('.page-recap').exists()) {
        var recapModel = new RecapModel();
        var recapPage = new RecapPage(recapModel);

        recapPage.initEvents();
    }
}
function initPageDevis() {
    if ($('.form-devis').exists()) {
        var subscriptionModel = new SubscriptionModel();
        var devisPage = new DevisPage(subscriptionModel);

        devisPage.initEvents();
    }
}
function initPageOffre() {
    if ($('.page-offres').exists()) {
        var offrePage = new OffrePage();

        offrePage.initEvents();
    }
}
function initComponentFormNewsletter() {
    if ($('.form-register-newsletter').exists()) {
        var subscriptionModel = new SubscriptionModel();
        var formNewsletter = new FormNewsletterComponent(subscriptionModel);

        formNewsletter.initEvents();
    }
}
function initComponentButtonLogout(model) {
    if ($('#logout').exists()) {
        var btnLogoutComponent = new BtnLogoutComponent(model);

        btnLogoutComponent.initEvents();
    }
}
function initComponentFormMdpReset(model) {
    if ($('.form-mdp-reset').exists()) {
        var formMdpResetComponent = new FormMdpResetComponent(model);

        formMdpResetComponent.initEvents();
    }
}
function initComponentFormMdpForget(model) {
    if ($('.form-mdp-forget').exists()) {
        var formMdpForgetComponent = new FormMdpForgetComponent(model);

        formMdpForgetComponent.initEvents();
    }
}
function initComponentFormOffrirArticleEnvoi() {
    if ($('.form-offrirarticle-envoi').exists()) {
        var offrirArticleModel = new OffrirArticleModel();
        var formOffrirArticle = new FormOffrirArticle(offrirArticleModel);

        formOffrirArticle.initEvents();
    }
}
function initComponentHeader() {
    var comp = new HeaderComponent();
    comp.initEvents();
}
function initComponentAccordionLanding() {
    if ($('#accordionLanding').exists()) {
        var accordionLanding = new AccordionLanding();

        accordionLanding.initEvents();
    }
}
function initComponentArticle() {
    if ($('article').exists()) {
        var articleComponent = new ArticleComponent();

        articleComponent.initEvents();
    }
}
function initComponentAlerteCarousel() {
    if ($('.alertes-carousel').exists()) {
        var alertesCarouselComponent = new AlertesCarouselComponent();

        alertesCarouselComponent.initEvents();
    }
}
function initComponentListKeywords(veilleModel) {
    if ($('.list-keywords').exists() || $('.landing-keywords').exists()) {
        var veillesComponent = new VeillesComponent(veilleModel);

        veillesComponent.initEvents();
    }
}
function initComponentTools() {
    if ($('.tools').exists()) {
        var articleModel = new ArticleModel();
        var articleToolsComponent = new ArticleToolsComponent(articleModel);

        articleToolsComponent.initEvents();
    }
}
function initComponentListArticles() {
    if ($('.list-articles').exists()) {
        var articleModel = new ArticleModel();
        var articlesComponent = new ArticlesComponent(articleModel);

        articlesComponent.initEvents();
    }
}
function initComponentFormContact() {
    if ($('form.form-contact').exists()) {
        var contactModel = new ContactModel();
        var formContactComponent = new FormContactComponent(contactModel);

        formContactComponent.initEvents();
    }
}
function initComponentFormContactModal() {
    if ($('form.form-contact-modal').exists()) {
        var contactModel = new ContactModel();
        var formContactModalComponent = new FormContactModalComponent(contactModel);

        formContactModalComponent.initEvents();
    }
}
function initComponentFormLicenceGlobale() {
    if ($('form.form-licence-globale').exists()) {
        var licenceGlobaleModel = new LicenceGlobaleModel();
        var formLicenceGlobaleComponent = new FormLicenceGlobaleComponent(licenceGlobaleModel);

        formLicenceGlobaleComponent.initEvents();
    }
}
function initComponentFormUnsub() {
    if ($('.form-unsub').exists()) {
        var subscriptionModel = new SubscriptionModel();
        var formUnsubscribeComponent = new FormUnsubscribeComponent(subscriptionModel);

        formUnsubscribeComponent.initEvents();
    }
}
function initComponentFiltersV2() {
    if ($('.page-recherche').exists()) {
        var filtersComponentV2 = new FiltersComponentV2();
        filtersComponentV2.initEvents();

        var filtersMobileComponentV2 = new FiltersMobileComponentV2();
        filtersMobileComponentV2.initEvents();
    }
}
function initComponentFilters() {
    if ($('.page-liste').exists()) {
        var filtersComponent = new FiltersComponent();
        filtersComponent.initEvents();

        var filtersMobileComponent = new FiltersMobileComponent();
        filtersMobileComponent.initEvents();
    }
}
function initComponentBlocAccount() {
    if ($('.bloc-account').exists()) {
        var blocAccountComponent = new BlocAccountComponent();

        blocAccountComponent.initEvents();
    }
}
function initComponentBlocAbo() {
    if ($('.bloc-abo').exists()) {
        var blocAboComponent = new BlocAboComponent();

        blocAboComponent.initEvents();
    }
}
function initComponentMenutop() {
        var menuTopComponent = new MenuTopComponent();

        menuTopComponent.initEvents()
}
function initComponentMenuInsiders() {
    if ($('.menu-insiders').exists()) {
        var menuInsidersComponent = new MenuInsidersComponent();

        menuInsidersComponent.initEvents();
    }
}
function initComponentMenuFeuilleton() {
    if ($('.menu-feuilletons').exists()) {
        var menuFeuilletonsComponent = new MenuFeuilletonsComponent();

        menuFeuilletonsComponent.initEvents();
    }
}
function initComponentNavFixed() {
    if ($('.nav-fixed').exists()) {
        var navFixedComponent = new NavFixedComponent();

        navFixedComponent.initEvents();
    }
}
function initComponentModalCookieConsent() {
    if ($('#modalCookieConsent').exists() && !isBrave()) {
        var modalCookieConsent = new ModalCookieConsent('#modalCookieConsent', '#modalCookieConsentSettings');

        modalCookieConsent.initEvents();
    }
}
function initComponentModalCookieConsentSettings() {
    if ($('#modalCookieConsentSettings').exists()) {
        var modalCookieConsentSettings = new ModalCookieConsentSettings('#modalCookieConsentSettings');

        modalCookieConsentSettings.initEvents();
    }
}
function initComponentModalSearch() {
    if ($('.modal-search').exists()) {
        var searchModalComponent = new SearchModalComponent();
        searchModalComponent.initEvents();
    }
}
function initComponentBtnMoreArticle() {
    if ($('.btn-more-articles').exists()) {
        var searchModel2 = new SearchModel();
        var btnMoreArticlesComponent = new BtnMoreArticlesComponent(searchModel2);

        btnMoreArticlesComponent.initEvents();
    }
}
function initComponentButtonScrollUp() {
    if ($('.btn-scroll-up').exists()) {
        var btnScrollUpComponent = new BtnScrollUpComponent();

        btnScrollUpComponent.initEvents();
    }
}
function initComponentBannerNewsletter() {
    if ($('#sticky-banner').exists()) {
        var bannerNewsletterComponent = new BannerNewsletterComponent();

        bannerNewsletterComponent.initEvents();
    }
}
function initComponentBannerOfferPme() {
    if ($('.banner-offer-header').exists()) {
        var bannerPmeComponent = new BannerOfferPmeComponent();
        bannerPmeComponent.initEvents();
    }
}
function initComponentMessages() {
    if ($('body > .messages').exists()) {
        var messagesComponent = new MessagesComponent();

        messagesComponent.initEvents();
    }
}
function initComponentMessagePush() {
    if ($('.message-push-notification').exists()) {
        var messageNotifComponent = new MessageNotifComponent();

        messageNotifComponent.initEvents();
    }
}
function initComponentMessageCookie() {
    if ($('.message-cookies').exists()) {
        var messageCookiesComponent = new MessageCookiesComponent();

        messageCookiesComponent.initEvents();
    }
}
function initComponentMenuleft() {
    if ($('.menuleft').exists()) {
        var menuLeftComponent = new MenuLeftComponent();

        menuLeftComponent.initEvents();
    }
}
function initComponentMenuright() {
    if ($('.menuright').exists()) {
        var menuRightComponent = new MenuRightComponent();

        menuRightComponent.initEvents();
    }
}
function initComponentTransactionCommand() {
    if ($('.transaction-command').exists()) {
        var transactionCommandComponent = new TransactionCommandComponent();

        transactionCommandComponent.initEvents();
    }
}
function initComponentCarte() {
    if ($('.ZoneCarte').exists()) {
        var carteModel = new CarteModel();
        var carteComponent = new CarteComponent(carteModel);

        carteComponent.initEvents();
    }
}
function initComponentModalDevis() {
    if ($('.modal-devis').exists()) {
        var subscriptionModel = new SubscriptionModel();
        var modalDevisComponent = new ModalDevisComponent(subscriptionModel);

        modalDevisComponent.initEvents();
    }
}
function initComponentCarouselUne() {
    if ($('.carousel-unes').exists()) {
        var editionModel = new EditionModel();
        var unesCarouselComponent = new UnesCarouselComponent(editionModel);

        unesCarouselComponent.initEvents();
    }
}
function initComponentModalImgFullscreen() {
    if ($('.modal-img-fullscreen').exists()) {
        var modalImgFullscreenComponent = new ModalImgFullscreenComponent($('.modal-img-fullscreen'));

        modalImgFullscreenComponent.initEvents();
    }
}
function initComponentProgressReading() {
    if ($('.page-article').exists() && $('#progressReading').exists()) {
        var progressReading = new ProgressReading('#progressReading', '.article');

        progressReading.initEvents();
    }
    if ($('.page-insiders').exists() && $('#progressReading').exists()) {
        var progressReading2 = new ProgressReading('#progressReading', '.article');

        progressReading2.initEvents();
    }
}
function initComponentProgressBar() {
    if ($('#progressBar').exists()) {
        var progressBar = new ProgressReading('#progressBar', '.page');

        progressBar.initEvents();
    }
}
function initComponentVeilleFeuilleton(veilleModel) {
    if ($('.btn-veille-feuilleton').exists()) {
       
       var veilleFeuilletonComponent = new VeilleFeuilletonComponent(veilleModel);
        veilleFeuilletonComponent.initEvents();
    }
}
function initialisationPaywallPoool() {

    if (window.PAYWALL_EXTERNAL_ACTIVATED === false) return;
    if ($('#poool-widget').exists()) {
        var pooolPaywallComponent = new PooolPaywallComponent();
        pooolPaywallComponent.initEvents();
    }
}
function initialisationEngagePoool() {
    var pooolEngageComponent = new PooolEngageComponent();
    pooolEngageComponent.initEvents();
}
function initialisationCountdown() {
    if ($('.offer-countdown').exists()) {
        var countdownComponent = new CountdownComponent();
        countdownComponent.initEvents();
    }
}
function initComponentBannerLancementLaLettre() {
    if ($('.banner-lalettre-formule').exists()) {
        var bannerLancementLaLettre = new BannerLancementLaLettreComponent();
        bannerLancementLaLettre.initEvents();
    }
}